import React from 'react';
import './work.css';

function UOttawa () {
  return (
    <div className='section body-section-below-title'>
      <div className='experience-logos'>
        <a
          href='https://www.uottawa.ca/en'
          style={{ cursor: 'pointer' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            className='experience-company-logo'
            alt='University of Ottawa logo'
            src='/assets/uottawa.png'
          />
        </a>
      </div>
      <div className='experience-text'>
        <div className='experience-title'>
          <div style={{ flexDirection: 'column' }}>
            <span style={{ fontSize: '22px', fontWeight: 'lighter' }}>
              Software Developer
            </span>
            <br />
            <span style={{ fontSize: '14px', fontWeight: 'lighter' }}>
              University of Ottawa, Ottawa, Canada
            </span>
          </div>
          <span style={{ fontWeight: 'lighter' }}>12/2013 - 08/2014</span>
        </div>

        <div className='experience-body'>
          <ul>
            <li>
              Build a database record of 80 million BLAST results to study
              microbial secondary metabolite biosynthesis.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default UOttawa;
